import DOMPurify from "dompurify";
import { useEffect } from "react";

function FacilityMap({
  map,
  onFacilityClick,
  activeFacilityId,
}: {
  map: string;
  onFacilityClick: (facilityId: string) => void;
  activeFacilityId: string;
}) {
  useEffect(() => {
    const mapElements = document.getElementsByClassName("map-clickable-area");

    for (let i = 0; i < mapElements.length; i++) {
      const element = mapElements[i];

      element.addEventListener("click", () => {
        const facilityId = element.getAttribute("id");

        if (facilityId) {
          onFacilityClick(facilityId);
        }
      });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (activeFacilityId) {
      const mapElements = document.getElementsByClassName("map-clickable-area");

      for (let i = 0; i < mapElements.length; i++) {
        const element = mapElements[i];

        if (element.getAttribute("id") === activeFacilityId) {
          element.classList.add("active");
        } else {
          element.classList.remove("active");
        }
      }
    }
  }, [activeFacilityId]);

  return map ? (
    <div
      className="o-facility-navigation__map"
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(map ?? ""),
      }}
    ></div>
  ) : (
    <></>
  );
}

export default FacilityMap;
